<div class="ob">
  <div class="ob-dots">
    <span class="d" [class.on]="step >= 1"></span>
    <span class="d" [class.on]="step >= 2"></span>
    <span class="d" [class.on]="step >= 3"></span>
    <span class="d" [class.on]="step >= 4"></span>
  </div>

  <!-- 1: welcome + name -->
  <div class="ob-screen" *ngIf="step === 1">
    <h2>{{ 'shell.onboard.s1.title' | translate }}</h2>
    <p class="ob-body">{{ 'shell.onboard.s1.body' | translate }}</p>
    <label class="ob-label">{{ 'shell.onboard.s1.nameLabel' | translate }}</label>
    <input class="ob-input" type="text" [(ngModel)]="name"
           [attr.placeholder]="'shell.onboard.s1.namePlaceholder' | translate" />
    <p class="ob-privacy">{{ 'shell.onboard.s2.privacy' | translate }}</p>
    <button class="ob-btn" [disabled]="!name?.trim()" (click)="next()">
      {{ 'shell.onboard.s1.cta' | translate }}
    </button>
  </div>

  <!-- 2: about you -->
  <div class="ob-screen" *ngIf="step === 2">
    <h2>{{ 'shell.onboard.s2.title' | translate }}</h2>
    <p class="ob-body">{{ 'shell.onboard.s2.body' | translate }}</p>

    <label class="ob-label">{{ 'shell.onboard.s2.birthYear' | translate }}</label>
    <select class="ob-input" [(ngModel)]="birthYear">
      <option [ngValue]="null" disabled selected></option>
      <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
    </select>

    <label class="ob-label">{{ 'shell.onboard.s2.contraception' | translate }}</label>
    <div class="ob-opts">
      <button class="ob-opt" *ngFor="let o of contraOpts"
              [class.sel]="contraception === o" (click)="contraception = o">
        {{ 'shell.onboard.contraOpts.' + o | translate }}
      </button>
    </div>

    <label class="ob-label">{{ 'shell.onboard.s2.cycle' | translate }}</label>
    <div class="ob-opts">
      <button class="ob-opt" *ngFor="let o of cycleOpts"
              [class.sel]="cycleStatus === o" (click)="cycleStatus = o">
        {{ 'shell.onboard.cycleOpts.' + o | translate }}
      </button>
    </div>

    <p class="ob-privacy">{{ 'shell.onboard.s2.privacy' | translate }}</p>
    <button class="ob-btn" [disabled]="!birthYear || !contraception || !cycleStatus" (click)="next()">
      {{ 'shell.onboard.s2.cta' | translate }}
    </button>
  </div>

  <!-- 3: pick tools -->
  <div class="ob-screen" *ngIf="step === 3">
    <h2>{{ 'shell.onboard.s3.title' | translate }}</h2>
    <p class="ob-body">{{ 'shell.onboard.s3.body' | translate }}</p>

    <div class="ob-cat" *ngFor="let cat of cats">
      <div class="ob-cat-label" [style.color]="catColor(cat)">{{ 'shell.cats.' + cat | translate }}</div>
      <div class="ob-tools">
        <button class="ob-tool" *ngFor="let tool of toolsIn(cat)"
                [class.sel]="selected[tool.id]"
                [style.--tc]="toolColor(tool)"
                (click)="toggleTool(tool.id)">
          {{ toolName(tool.id) }}
        </button>
      </div>
    </div>

    <div class="ob-hint" [class.ok]="selectedCount() >= 3">
      {{ 'shell.onboard.s3.hint' | translate }} ({{ selectedCount() }})
    </div>
    <button class="ob-btn" [disabled]="selectedCount() < 3" (click)="next()">
      {{ 'shell.onboard.s3.cta' | translate }}
    </button>
    <button class="ob-ghost" (click)="selectAll()">{{ 'shell.onboard.s3.selectAll' | translate }}</button>
  </div>

  <!-- 4: ready -->
  <div class="ob-screen" *ngIf="step === 4">
    <h2>{{ 'shell.onboard.s4.title' | translate }}</h2>
    <p class="ob-body">{{ 'shell.onboard.s4.body' | translate:{ n: selectedCount() } }}</p>
    <button class="ob-btn" [disabled]="busy" (click)="finish(true)">
      {{ 'shell.onboard.s4.cta' | translate }}
    </button>
    <button class="ob-ghost" [disabled]="busy" (click)="finish(false)">
      {{ 'shell.onboard.s4.skip' | translate }}
    </button>
    <p class="ob-disc">{{ 'shell.onboard.s4.disclaimer' | translate }}</p>
  </div>
</div>
